/** Build-time thumbnail keys + sizes, shared by scripts/thumbs.tsx and the runtime (art/Thumb.tsx). */
export const THUMB_WIDTHS = [160, 320, 480] as const;
export const drawingThumbKey = (drawingId: string) => `d:${drawingId}`;
export const vignetteThumbKey = (specId: string, drawingId: string) => `vg:${specId}:${drawingId}`;
/** Cheap staleness guard (a downloaded pack may change a drawing's art): layer count + viewBox. */
export const artSig = (art: { vb: readonly number[]; layers: readonly unknown[] }) => `${art.layers.length}:${art.vb.join('x')}`;
